<template>
  <AppLayout title="Caixas">
    <div class="table-card">
      <table class="table">
        <thead>
          <tr>
            <th>Operador</th>
            <th>Aberto em</th>
            <th>Fechado em</th>
            <th>Abertura</th>
            <th>Fechamento</th>
            <th>Total vendido</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="caixa in lista_caixas" :key="caixa.id">
            <td>{{ caixa.operator?.name ?? '-' }}</td>
            <td>{{ formaterService.dateTime(caixa.created_at) }}</td>
            <td>{{ formaterService.dateTime(caixa.updated_at) }}</td>
            <td>{{ formaterService.currency(caixa.open) ?? 'R$ 0,00' }}</td>
            <td>{{ formaterService.currency(caixa.close) ?? 'R$ 0,00' }}</td>
            <td>{{ formaterService.currency(caixa.sell_total) ?? 'R$ 0,00' }}</td>
            <td style="width:50px">
              <router-link :to="{ name: 'cashier-detail', params: { id: caixa.id } }" class="btn btn-info btn-sm" title="Ver resumo do caixa">
                <i class="bi bi-info-circle-fill"></i>
              </router-link>
            </td>
          </tr>
          <tr v-if="!lista_caixas.length">
            <td colspan="7" class="text-center text-muted">Nenhum caixa fechado ainda.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Paginação -->
    <nav aria-label="Paginação de caixas" class="mt-3">
      <ul class="pagination justify-content-center">
        <li class="page-item" :class="{ disabled: currentPage === 1 }">
          <button class="page-link" @click="changePage(currentPage - 1)" :disabled="currentPage === 1">
            <i class="bi bi-chevron-left"></i> Anterior
          </button>
        </li>
        <li class="page-item" v-for="p in pages" :key="p" :class="{ active: p === currentPage }">
          <button class="page-link" @click="changePage(p)">{{ p }}</button>
        </li>
        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
          <button class="page-link" @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages">
            Próximo <i class="bi bi-chevron-right"></i>
          </button>
        </li>
      </ul>
    </nav>
  </AppLayout>
</template>
<script>
import { onMounted, ref, computed } from 'vue';
import AppLayout from "@/components/AppLayout.vue";
import { caixas } from "@/models/caixas";
import formaterService from "@/services/formaterService";

export default {
  name: 'CashiersView',
  components: {
    AppLayout
  },
  setup(props) {

    const Caixas = caixas();
    const lista_caixas = ref([]);

    const currentPage = ref(1);
    const totalPages = ref(1);
    const totalCaixas = ref(0);
    const perPage = ref(15);

    const pages = computed(() => {
      const p = [];
      for (let i = 1; i <= totalPages.value; i++) {
        p.push(i);
      }
      return p;
    });

    const changePage = (page) => {
      if (page < 1 || page > totalPages.value) return;
      currentPage.value = page;
      refresh(page);
    }

    const refresh = async (page = 1) => {
      const retorno = await Caixas.list(page);
      if (retorno) {
        lista_caixas.value = retorno.data;
        totalPages.value = retorno.pages || 1;
        currentPage.value = retorno.page || 1;
        totalCaixas.value = retorno.total || 0;
        perPage.value = retorno.perPage || 15;
      }
    }

    onMounted(function () {
      refresh();
    });

    return {
      lista_caixas,
      formaterService,
      currentPage,
      totalPages,
      totalCaixas,
      perPage,
      pages,
      changePage
    }
  },
}
</script>
